import { INavConfigDesktop } from '@pendwa/common-browser/components/Navs/Nav/types.js';
import { IContextPageDataViewer } from '@pendwa/common-browser/context/PageData/index.js';
import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
import { filterOutNullOrUndefined } from '@pendwa/common/utils/isDefinedAndNotNull.js';

export const middleSection = (params: {
  viewer?: IContextPageDataViewer;
}): INavConfigDesktop['middle_section'] => {
  return {
    links: filterOutNullOrUndefined([
      domain_env_pendwa_app
        ? {
            label: 'Shows',
            navigate: {
              description: 'All Shows.',
              href: rootRoutes.shows.main.get(),
            },
          }
        : undefined,
      domain_env_africacrosswords_com
        ? {
            label: 'Crosswords',
            navigate: {
              description: 'All Crosswords.',
              href: rootRoutes.shows.main.get(),
            },
          }
        : undefined,
      domain_env_swiftcomment_com
        ? {
            label: 'Dashboard',
            navigate: {
              description: 'Reply to comments.',
              href: rootRoutes.sc.main.get(),
            },
          }
        : undefined,
      !params.viewer
        ? {
            label: 'Sign In',
            navigate: {
              description: 'Log in to your account.',
              href: rootRoutes.app.account.login.get(window.location.href),
            },
          }
        : undefined,
      !params.viewer
        ? {
            label: 'Sign Up',
            navigate: {
              description: 'Create your account today.',
              href: rootRoutes.app.account.create.get(window.location.href),
            },
          }
        : undefined,
    ]),
  };
};
